import { operatorEditPath } from '@/common/app/path'
import { Operator } from '@/common/model/operator'

import TextButton from '@/components/view/atoms/button/TextButton'
import ClickableTableRow from '@/components/view/atoms/table/ClickableTableRow'
import TableRowItem from '@/components/view/atoms/table/TableRowItem'
import Text from '@/components/view/atoms/text/Text'

interface Props {
  operator: Operator
  isScrolled: boolean
}

const OperatorListRow = ({ operator, isScrolled }: Props) => {
  return (
    <ClickableTableRow href={operatorEditPath(operator.id)}>
      <TableRowItem scrollShadow={isScrolled} width={64}>
        <Text size={14}>{operator.id}</Text>
      </TableRowItem>
      <TableRowItem width={200}>
        <TextButton link={operatorEditPath(operator.id)}>{operator.email}</TextButton>
      </TableRowItem>
      <TableRowItem width={200}>
        <Text size={14}>{operator.name}</Text>
      </TableRowItem>
    </ClickableTableRow>
  )
}

export default OperatorListRow
